/**
 * EmailSupport — botão flutuante de contato por email (PR #224).
 *
 * Substitui o antigo SupportChat (chat in-app com bot LLM) por um
 * canal direto de email pro suporte. Decisão de produto 2026-05-28:
 * "comunicações por email ao suporte apenas".
 *
 * Mantém o componente exportado como `SupportChat` pra não quebrar o
 * import existente em App.tsx.
 */
import { useState } from "react";
import { Mail, X } from "lucide-react";

const EMAIL_SUPORTE = "suporte@acordei.app.br";
const ASSUNTO_DEFAULT = "Dúvida sobre a ACORDEI!";
const SUGESTOES_ASSUNTO = [
  "Dúvida sobre mediação extrajudicial",
  "Como abrir um caso",
  "Acompanhamento do meu protocolo",
  "Problema técnico no app",
  "Outro assunto",
];

export default function SupportChat() {
  const [open, setOpen] = useState(false);

  const abrirEmail = (assunto: string) => {
    const url = `mailto:${EMAIL_SUPORTE}?subject=${encodeURIComponent(assunto)}`;
    window.location.href = url;
    setOpen(false);
  };

  return (
    <>
      {/* Botão flutuante */}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Fechar opções de suporte" : "Falar com o suporte por email"}
        style={{
          position: "fixed",
          bottom: 28,
          right: 28,
          zIndex: 9999,
          width: 56,
          height: 56,
          borderRadius: "50%",
          background: open ? "oklch(0.55 0.22 290)" : "oklch(0.75 0.18 200)",
          color: "oklch(0.08 0.01 260)",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 24px oklch(0 0 0 / 0.4)",
          transition: "background 0.2s, transform 0.15s",
        }}
        onMouseDown={(e) => ((e.currentTarget as HTMLButtonElement).style.transform = "scale(0.93)")}
        onMouseUp={(e) => ((e.currentTarget as HTMLButtonElement).style.transform = "scale(1)")}
      >
        {open ? <X size={22} aria-hidden="true" /> : <Mail size={22} aria-hidden="true" />}
      </button>

      {/* Card de opções */}
      {open && (
        <div
          role="dialog"
          aria-modal="false"
          aria-label="Falar com o suporte"
          style={{
            position: "fixed",
            bottom: 100,
            right: 28,
            zIndex: 9998,
            width: "min(360px, calc(100vw - 56px))",
            background: "oklch(0.13 0.03 240)",
            border: "1px solid oklch(0.28 0.04 255)",
            borderRadius: 16,
            boxShadow: "0 8px 40px oklch(0 0 0 / 0.5)",
            padding: 20,
            color: "oklch(0.96 0.005 240)",
            fontFamily: "'Space Grotesk', sans-serif",
          }}
        >
          <h3
            style={{
              fontSize: 16,
              fontWeight: 700,
              marginBottom: 8,
              color: "oklch(0.96 0.005 240)",
            }}
          >
            Falar com a equipe
          </h3>
          <p style={{ fontSize: 13, color: "oklch(0.65 0.025 255)", marginBottom: 16, lineHeight: 1.5 }}>
            Toda comunicação com a ACORDEI! é por email. Escolha o assunto para abrir
            seu app de email:
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {SUGESTOES_ASSUNTO.map((assunto) => (
              <button
                key={assunto}
                onClick={() => abrirEmail(assunto)}
                style={{
                  textAlign: "left",
                  background: "oklch(0.18 0.04 250)",
                  border: "1px solid oklch(0.30 0.04 255)",
                  borderRadius: 10,
                  padding: "10px 14px",
                  fontSize: 13,
                  color: "oklch(0.92 0.01 255)",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  transition: "background 0.15s, border-color 0.15s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "oklch(0.22 0.05 250)";
                  e.currentTarget.style.borderColor = "oklch(0.40 0.06 250)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "oklch(0.18 0.04 250)";
                  e.currentTarget.style.borderColor = "oklch(0.30 0.04 255)";
                }}
              >
                {assunto}
              </button>
            ))}
          </div>

          <p style={{ fontSize: 11, color: "oklch(0.50 0.025 255)", marginTop: 14, textAlign: "center" }}>
            Email: <span style={{ color: "oklch(0.85 0.15 200)" }}>{EMAIL_SUPORTE}</span>
          </p>
        </div>
      )}
    </>
  );
}
